import React, { useEffect, useState, Component } from 'react';
import { ExternalLinkIcon, GlobeIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface RichLinkCardProps {
  url: string;
  metadata?: {
    title?: string;
    description?: string;
    favicon?: string;
  };
}
export function RichLinkCard({
  url,
  metadata
}: RichLinkCardProps) {
  const [favicon, setFavicon] = useState<string | null>(null);
  useEffect(() => {
    // Try to load favicon
    try {
      const urlObj = new URL(url);
      const faviconUrl = `${urlObj.protocol}//${urlObj.hostname}/favicon.ico`;
      setFavicon(faviconUrl);
    } catch {
      // Invalid URL
    }
  }, [url]);
  const displayTitle = metadata?.title || extractTitleFromUrl(url);
  const displayDomain = extractDomain(url);
  return <motion.a href={url} target="_blank" rel="noopener noreferrer" initial={{
    opacity: 0,
    y: 5
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2
  }} className="block bg-slate-900/60 border border-slate-700 rounded-lg p-4 hover:border-blue-500/50 hover:bg-slate-900/80 transition-all group" data-id="element-354">
      <div className="flex items-start gap-3" data-id="element-355">
        <div className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0 group-hover:bg-slate-700 transition-colors" data-id="element-356">
          {favicon ? <img src={favicon} alt="" className="w-5 h-5" onError={() => setFavicon(null)} data-id="element-357" /> : <GlobeIcon className="w-5 h-5 text-slate-400" data-id="element-358" />}
        </div>
        <div className="flex-1 min-w-0" data-id="element-359">
          <div className="flex items-start justify-between gap-2" data-id="element-360">
            <h4 className="text-sm font-medium text-white group-hover:text-blue-400 transition-colors truncate" data-id="element-361">
              {displayTitle}
            </h4>
            <ExternalLinkIcon className="w-4 h-4 text-slate-500 group-hover:text-blue-400 transition-colors flex-shrink-0" data-id="element-362" />
          </div>
          {metadata?.description && <p className="text-xs text-slate-400 mt-1 line-clamp-2" data-id="element-363">
              {metadata.description}
            </p>}
          <p className="text-xs text-slate-500 mt-1 truncate" data-id="element-364">
            {displayDomain}
          </p>
        </div>
      </div>
    </motion.a>;
}
function extractTitleFromUrl(url: string): string {
  try {
    const urlObj = new URL(url);
    const path = urlObj.pathname.split('/').filter(Boolean).pop();
    if (path) {
      return decodeURIComponent(path).replace(/[-_]/g, ' ').replace(/\.\w+$/, '');
    }
    return urlObj.hostname;
  } catch {
    return url;
  }
}
function extractDomain(url: string): string {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname;
  } catch {
    return url;
  }
}